import { useEffect, useRef } from "react";
import { useLocation } from "@/lib/router-compat";
import { dgPageView } from "@/lib/dataGraph";

/**
 * Silently tracks page views for the Home Approach Data Graph®.
 * Place once inside BrowserRouter.
 */
export default function DataGraphPageTracker() {
  const location = useLocation();
  const prev = useRef(location.pathname);

  useEffect(() => {
    dgPageView(location.pathname);
    prev.current = location.pathname;
  }, [location.pathname]);

  return null;
}
